import {translations} from 'presentation/translations-new';

const {frontTitle, rightTitle, leftTitle} =
	translations['pt-br'].others.facialBiometric.facePhoto.faceCamera;

const STEP_CONFIG = {
	front: {title: frontTitle, icon: 'face'},
	right: {title: rightTitle, icon: 'face-right'},
	left: {title: leftTitle, icon: 'face-left'},
};

export {STEP_CONFIG};
